export enum ExportTypeEnum {
	TRADES = 'trades',
	USER_DATA = 'user_data',
	COURSES_USERS = 'courses_users',
	COURSES_CHALLENGE_PARTICIPANTS = 'courses_challenge_participants',
}
